import { getCurrentSeasonId } from '$lib/er/season/season';
import { api, type ResultOf } from '$lib/erar/api';
import { error } from '@sveltejs/kit';
import type { LayoutLoad } from './$types';
import { APIResponseError } from '$lib/error';

export const load = (async ({ fetch, params, url }) => {
  let playerResponse: ResultOf<'GET /player/by-name/[name]'>;
  try {
    playerResponse = await api('GET /player/by-name/[name]', {
      params: { name: encodeURIComponent(params.name) },
      fetch,
    });
  } catch (e) {
    if (e instanceof APIResponseError) {
      if (e.response.status === 404) {
        throw error(e.response.status, { code: e.response.status, message: params.name });
      } else {
        throw error(e.response.status, {
          code: e.response.status,
          message: await e.response.text(),
        });
      }
    } else {
      throw error(500, { code: 500, message: 'Unexpected Server Error' });
    }
  }

  const {
    result: { id, name, level, updatedAt },
    tags,
  } = playerResponse;

  try {
    const { result: seasons } = await api('GET /static/seasons', { fetch });

    let seasonIdText = url.searchParams.get('season') ?? undefined;
    if (seasonIdText === 'all') {
      seasonIdText = undefined;
    }
    let queueText = url.searchParams.get('queue') ?? undefined;
    if (queueText === 'all') {
      queueText = undefined;
    }

    const fetchPartners = api('GET /player/[id]/partners', { params: { id }, fetch });

    const fetchSeasonStatistics = api('GET /player/[id]/statistics', {
      params: { id },
      query: { seasonId: seasonIdText, queue: queueText },
      fetch,
    });
    const fetchQueues = api('GET /queues/by-player/[id]', { params: { id }, fetch });
    const fetchQueueHistory = api('GET /queues/by-player/[id]/history', {
      params: { id },
      query: { seasonId: seasonIdText },
      fetch,
    });
    const fetchMatches = api('GET /matches/by-player/[id]', {
      params: { id },
      query: {
        page: url.searchParams.get('page') ?? '0',
        seasonId: seasonIdText,
        queue: queueText,
      },
      fetch,
    });

    const [queues, queueHistory, matches] = await Promise.all([
      fetchQueues,
      fetchQueueHistory,
      fetchMatches,
    ]);

    return {
      seasons,
      seasonId: seasonIdText ? parseInt(seasonIdText) : 'all',
      queueType: queueText ?? 'all',
      player: {
        id,
        name,
        level,
        updatedAt,
        tags,
        queues: queues.result,
        history: queueHistory.result,
        matches,
        partners: fetchPartners,
        seasonStatistics: fetchSeasonStatistics,
      },
    };
  } catch (e) {
    if (e instanceof APIResponseError) {
      console.error(await e.response.json());
      if (e.response.status !== 416) {
        // throw error(500);
      }
    }
  }
}) satisfies LayoutLoad;
